// @ts-nocheck
import React, { useState } from 'react';
import { NextPage } from 'next';
import Image from 'next/image';
import Layout from '../../components/layout';
import useVinDecoder from '../../hooks/use-vin-decoder';
import Link from '../../components/link';
import GenericContainer from '../../components/@container/generic-container';

const VinDecoderPage: NextPage = () => {
  const [error, setError] = useState('');
  const [vin, setVin] = useState('');
  const [vinData, setVinData] = useState(null);
  const vinDecoder = useVinDecoder();

  const onSubmit = async () => {
    if (
      !(
        vin.toLowerCase().startsWith('yv1') ||
        vin.toLowerCase().startsWith('yv4') ||
        vin.toLowerCase().startsWith('lvy') ||
        vin.toLowerCase().startsWith('7jr') ||
        vin.toLowerCase().startsWith('lyv')
      )
    ) {
      setError('This is not a Volvo VIN Number.');
    } else {
      const data = await vinDecoder(vin.toUpperCase());

      if (data.errors.length) {
        setError(data.errors.join(', '));
      } else {
        setError('');
      }

      setVinData(data);
    }
  };

  return (
    <Layout title="VIN Decoder">
      <GenericContainer
        title="VIN Decoder"
        breadcrumb={{ url: '/resources', text: 'Back to Resources' }}
      >
        <section className="vin">
          <div className="vin-decoder">
            <span>VIN:</span>
            <input
              type="text"
              name="vin"
              id="vin"
              defaultValue={vin}
              onChange={(e) => setVin(e.target.value)}
            />
            <button onClick={onSubmit}>Decode</button>
            {error && <p>{error}</p>}
          </div>
          <div className="vin-decoder-info">
            <div className="row">
              <div className="col">
                <p>2009 and earlier</p>
                <Image
                  height="135px"
                  width="302px"
                  src={`${process.env.CDN_URL}/vin/vin-2009.gif`}
                  alt="2009 and earlier vin table"
                />
              </div>
              <div className="col">
                <p>2010+</p>
                <Image
                  height="135px"
                  width="302px"
                  src={`${process.env.CDN_URL}/vin/vin-2010.gif`}
                  alt="2010 and newer vin table"
                />
              </div>
            </div>
            <p className="reference">
              This vin decoder is for reference only, all information is subject
              to change.
            </p>
            <p>
              <Link
                href={`${process.env.CDN_URL}/vin/Volvo MY 2022 VIN Decoder.pdf`}
              >
                <a>MY2022 VIN Decoder - USA/Canada</a>
              </Link>
            </p>
          </div>
          {vinData && vinData.errors.length === 0 && (
            <div className="vin-grid">
              <div className="vin-tile header">
                <span>Type</span>
                <span>Value</span>
              </div>
              <div className="vin-tile">
                <span>Make</span>
                <span>{vinData.make}</span>
              </div>
              <div className="vin-tile">
                <span>Model</span>
                <span>{vinData.model}</span>
              </div>
              <div className="vin-tile">
                <span>Model Year</span>
                <span>{vinData.modelYear}</span>
              </div>
              <div className="vin-tile">
                <span>Engine Model</span>
                <span>{vinData.engine.model}</span>
              </div>
              <div className="vin-tile">
                <span>Engine Cylinders</span>
                <span>{vinData.engine.cylinders}</span>
              </div>
              <div className="vin-tile">
                <span>Engine Displacement</span>
                <span>{vinData.engine.displacement}</span>
              </div>
              <div className="vin-tile">
                <span>Engine Brake HP</span>
                <span>{vinData.engine.brakeHP}</span>
              </div>
              <div className="vin-tile">
                <span>Drive Type</span>
                <span>{vinData.driveType}</span>
              </div>
              <div className="vin-tile">
                <span>Vehicle Type</span>
                <span>{vinData.vehicleType}</span>
              </div>
              <div className="vin-tile">
                <span>Body</span>
                <span>{vinData.body}</span>
              </div>
              <div className="vin-tile">
                <span>Trim</span>
                <span>{vinData.trim}</span>
              </div>
              <div className="vin-tile">
                <span>Plant Information</span>
                <span>{vinData.factory.country}</span>
              </div>
              <div className="vin-tile">
                <span>Chassis</span>
                <span>{vin.substring(vin.length - 6)}</span>
              </div>
            </div>
          )}
        </section>
      </GenericContainer>
      {/* language=CSS */}
      <style jsx>{`
        section.vin {
          width: 100%;
        }

        .vin-decoder {
          text-align: center;
          padding-bottom: 1rem;
        }

        .vin-decoder span,
        .vin-decoder input {
          margin-right: 1rem;
        }

        .vin-decoder span {
          font-family: 'Volvo Novum', sans-serif;
        }

        .vin-decoder input[type='text'] {
          appearance: none;
          padding: 8px 10px;
          border: 1px solid transparent;
          border-radius: 5px;
          background: #eceff0;
          transition: all 0.3s ease-in-out;
        }

        .vin-decoder input[type='text']:focus {
          outline: none;
          border-color: #ddd;
        }

        .vin-decoder button {
          appearance: none;
          padding: 8px 10px;
          border: 1px solid transparent;
          border-radius: 5px;
          background-color: #707070;
          color: #ffffff;
          transition: all 0.3s ease-in-out;
        }

        .vin-decoder button:hover {
          color: #707070;
          background: #ffffff;
          border-color: #707070;
        }

        .vin-decoder-info {
          text-align: center;
          padding-top: 1rem;
          width: 100%;
          font-family: 'Volvo Novum', sans-serif;
        }

        .vin-decoder-info .row {
          display: flex;
          justify-content: space-between;
          width: 100%;
          gap: 1rem;
        }

        .vin-decoder-info .row .col {
          flex: 0 1 50%;
        }

        .reference {
          margin-top: 2rem;
        }

        .vin-grid {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .vin-tile {
          display: flex;
        }

        .vin-tile span:first-child {
          flex: 1 0 30%;
        }

        .vin-tile span {
          flex: 1 0 70%;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          font-weight: 400;
        }

        .vin-tile.header span {
          color: #707070;
          padding: 0 0 1rem;
          border-bottom: 1px solid #ddd;
        }

        a {
          color: #707070;
          transition: all 0.2s ease-in-out;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
        }

        a:hover {
          color: #333;
        }
      `}</style>
    </Layout>
  );
};

export default VinDecoderPage;
